<template>
  <div class="top-notice">Trials ends in 7 days</div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      user: state => state.user.data,
      ref: state => state.user.ref
    })
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "../style/scss/variables/colors";
.top-notice {
  text-align: center;
  background-color: rgb(9, 155, 195);
  color: white;
  padding: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/TopNotice.vue